<div class="d-flex">
  <span matSnackBarLabel class="d-flex align-items-center">
    {{ 'map.plotting.select_area' | translate }}
  </span>
  <span  class="plot-snackbar-actions d-flex justify-content-end align-items-center gap-2">
    <button mat-stroked-button  color="primary" (click)="onClose()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      *ngIf="!((plotService.isLayerDrawn$ | async) === false)"
      mat-flat-button
      matSnackBarAction
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'common.confirm' | translate }}
    </button>
  </span>
</div>
